/// <summary>
/// 行驶路线项 oyyh,20161008添加注释
/// </summary>
export class DriveRouteItem {

	constructor() {
		this.id=null;
		/// <summary>
		/// 下一街道名称
		/// </summary>
		this.nextStreetName = null;
		this.signage = null;
		/// <summary>
		/// 街道名称
		/// </summary>
		this.streetName = null;
		this.strguide = null;
		this.tollStatus = null;
		/// <summary>
		/// 转弯点经纬度
		/// </summary>
		this.turnlatlon = null;

		this.crsCode="EPSG:4326";
	}


	static GetDriveRouteItem(objProxy) {
		let routeItem=null;
		if(objProxy==null)return routeItem;
		routeItem =new DriveRouteItem();
		routeItem.nextStreetName=objProxy.nextStreetName;
		routeItem.signage=objProxy.signage;
		routeItem.streetName=objProxy.streetName;
		routeItem.strguide=objProxy.strguide;
		routeItem.tollStatus=objProxy.tollStatus;
		routeItem.turnlatlon=objProxy.turnlatlon;

		return routeItem;
	}


}//end DriveRouteItem

